var Handlebars = require("/Users/mauricengo/styleguide-test/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression;

  return "\n<div class=\"price price--sm\">\n  <span class=\"price__markdown\">$"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.pdp : depth0)) != null ? stack1.price : stack1), depth0))
    + "</span>\n  <span class=\"price__retail price__retail--strikethrough\">$"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.pdp : depth0)) != null ? stack1["regular-price"] : stack1), depth0))
    + "</span>\n</div>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/materials/modules/price/small-on-sale.html
// module id = 158
// module chunks = 0